import useAppSelector from "@/core/helpers/useAppSelector";
import { socialClubSelector } from "@/domains/auth/slice";
import AuthSignUpSuccess from "@/domains/auth/components/sign-up/AuthSignUpSuccess.tsx";

function AuthSignUpSuccessContainer() {
  const socialClub = useAppSelector(socialClubSelector);

  return <AuthSignUpSuccess socialClub={socialClub} />;
}

export default AuthSignUpSuccessContainer;
